import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeployParams } from 'src/app/deployParams';
import { SportsService } from 'src/app/services/sports.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { environment } from 'src/environments/environment';
declare var jQuery: any;

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.less']
})
export class BannerComponent implements OnInit {

  isMobileView = false;

  constructor(private utilityService: UtilityService, private sportsService: SportsService) {
    this.isMobileView = this.utilityService.mobileView;
  }

  ngOnInit(): void {
    setTimeout(() => {
      jQuery('.owl-carousel').owlCarousel({
          items: 1,
          // loop: this.isMobileView ? false : true,
          loop: false,
          autoplay: true,
          autoplayTimeout: 7000,
          autoplayHoverPause: true,
          dots: false,
          smartSpeed: 800,
          autoHeight: true
      });
    }, 200);
  }

  navigateToCompetition(){
    // this.router.navigate(['betting/prematch', { queryParams: {competitionId: '1-1060-17958'}}]);
    this.sportsService.openCompetitionFromBanner(environment.bannerSportId, environment.bannerRegionId, environment.bannerCompetitionId);
  }

}
